import axios from 'axios';
import {
    SET_TOPOLOGY_REQUEST,
    SET_TOPOLOGY_SUCCESS,
    SET_TOPOLOGY_ERROR,
    SET_TOPOLOGY_SPECIFIC_PAGE_REQUEST,
    SET_TOPOLOGY_SPECIFIC_PAGE_SUCCESS,
    SET_TOPOLOGY_SPECIFIC_PAGE_ERROR,
    SET_ALL_PRE_VALIDATION_CHECKS_REQUEST,
    SET_ALL_PRE_VALIDATION_CHECKS_SUCCESS,
    SET_ALL_PRE_VALIDATION_CHECKS_ERROR,
    SET_START_EXECUTION_REQUEST,
    SET_START_EXECUTION_SUCCESS,
    SET_START_EXECUTION_ERROR,
    SET_STOP_EXECUTION_SUCCESS,
    SET_STOP_EXECUTION_ERROR,
    SET_STOP_EXECUTION_REQUEST,

    SET_UPLOAD_TOPOLOGY_FILE_REQUEST,
    SET_UPLOAD_TOPOLOGY_FILE_SUCCESS,
    SET_UPLOAD_TOPOLOGY_FILE_ERROR,
    
    SET_DELETE_TOPOLOGY_DATA_REQUEST,
    SET_DELETE_TOPOLOGY_DATA_SUCCESS,
    SET_DELETE_TOPOLOGY_DATA_ERROR,

    SET_RESOURCES_TO_BE_CREATED_REQUEST,
    SET_RESOURCES_TO_BE_CREATED_SUCCESS,
    SET_RESOURCES_TO_BE_CREATED_ERROR,

    SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST,
    SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_SUCCESS,
    SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR,
} from './../../../constants/closeLoop/topology/index';


export const fetchTopologyData = () => (dispatch) => {
    try {
        dispatch({type: SET_TOPOLOGY_REQUEST});
        axios({
            url: '/close_loop/topology/handler',
            method: 'GET'
        }).then((response) => {
            if(response && response.status === 200) {
                const { data } = response;
                const alteredData = data['items'].map((item) => {
                    if (item['progress'] === 'running'){
                        item['execution'] = 'Stop'
                    }else {
                        item['execution'] = 'Validate'
                    }
                    return item;
                })
                dispatch({type: SET_TOPOLOGY_SUCCESS, items: alteredData, pages: data['pages']});
            } else {
                dispatch({type: SET_TOPOLOGY_ERROR, payload: 'Error occurred while fetching this request'});
            }
        }).catch((error) => {
            dispatch({type: SET_TOPOLOGY_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.error(error);
        const errorMsg = error.message || 'Error occurred while fetching this request!';
        dispatch({type: SET_TOPOLOGY_ERROR, payload: errorMsg});
    }
};


export const fetchSpecificPageTopologyData = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_TOPOLOGY_SPECIFIC_PAGE_REQUEST});
        axios({
            url: `/close_loop/topology/handler?page=${payload['page']}&per_page=7`,
            method: 'GET'
        }).then((response) => {
            if(response && response.status === 200) {
                const { data } = response;
                const alteredData = data['items'].map((item) => {
                   if (item['progress'] === 'running'){
                        item['execution'] = 'Stop'
                    }else {
                        item['execution'] = 'Validate'
                    }
                    return item;
                });
                dispatch({type: SET_TOPOLOGY_SPECIFIC_PAGE_SUCCESS, items: alteredData, pages: data['pages'], page: data['page']});
            } else {
                dispatch({type: SET_TOPOLOGY_SPECIFIC_PAGE_ERROR, payload: 'Error occurred while fetching this request'});
            }
        }).catch((error) => {
            dispatch({type: SET_TOPOLOGY_SPECIFIC_PAGE_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.error(error);
        const errorMsg = error.message || 'Error occurred while fetching this request!';
        dispatch({type: SET_TOPOLOGY_SPECIFIC_PAGE_ERROR, payload: errorMsg});
    }
}


export const performAllPreValidation = (payload) => (dispatch) => {
    const validationKey = "/get/status/validation-checks?check";
    const sceneGroupKey = "/get/status/cm-security-groups/validation-checks?cad_topology_job_uuid";
    try {
        dispatch({type: SET_ALL_PRE_VALIDATION_CHECKS_REQUEST, topologyId: payload['topologyId']});
        Promise.all([
            axios.get("/get/status/validation-checks?check=mongo-connection"),
            axios.get("/get/status/validation-checks?check=rabbitmq-connection"),
            axios.get("/get/status/validation-checks?check=config-ami-check"),
            axios.get("/get/status/validation-checks?check=terraform-check"),
            axios.get(`/get/status/cm-security-groups/validation-checks?cad_topology_job_uuid=${payload['topologyId']}`)
        ]).then((responses) => {
            if(responses) {
                const data = responses.map((item, index) => {
                    const queryAttribute = new URLSearchParams(item.config.url);
                    const params = Object.fromEntries(queryAttribute.entries());
                    if(index === responses.length - 1) {
                        return {
                            [params[sceneGroupKey]]: item.data
                        }
                    }
                    return {
                        [params[validationKey]]: item.data
                    }
                });
                dispatch({type: SET_ALL_PRE_VALIDATION_CHECKS_SUCCESS, config: data, topologyId: payload['topologyId']});
            }
        }).catch((error) => {
            console.error(error);
            dispatch({type: SET_ALL_PRE_VALIDATION_CHECKS_ERROR, payload: error.response.data.message || error.message, topologyId: payload['topologyId']});
        });
    } catch(error) {
        console.error(error);
        dispatch({type: SET_ALL_PRE_VALIDATION_CHECKS_ERROR, payload: error.message, topologyId: payload['topologyId']});
    }
}


export const startExecution = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_START_EXECUTION_REQUEST, topologyId: payload['cad_topology_id']});
        axios.post('/close_loop/start/virtual-validation', payload).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_START_EXECUTION_SUCCESS, topologyId: payload['cad_topology_id'], message: "Started execution!"});
            }
        }).catch((error) => {
            dispatch({type: SET_START_EXECUTION_ERROR, payload: error.response.data.message, topologyId: payload['topologyId']});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_START_EXECUTION_ERROR, payload: error.message, topologyId: payload['topologyId']});
    }
};
export const stopExecution = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_STOP_EXECUTION_REQUEST, topologyId: payload['topologyId']});
        axios.delete(`/close_loop/stop/virtual-validation?topology_uuid=${payload['topologyId']}`).then((response) => {
            console.log(response.status)
            if(response && response.status === 200) {
                dispatch({type: SET_STOP_EXECUTION_SUCCESS, topologyId: payload['topologyId'], message: "Stop Execution!"});
            }
        }).catch((error) => {
            dispatch({type: SET_STOP_EXECUTION_ERROR, payload: error.response.data.message, topologyId: payload['topologyId']});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_STOP_EXECUTION_ERROR, payload: error.message, topologyId: payload['topologyId']});
    }
};


export const uploadTopologyFile = (formPayload) => (dispatch) => {
    try {
        dispatch({type: SET_UPLOAD_TOPOLOGY_FILE_REQUEST});
        axios({
            url: '/close_loop/upload/topology-schema',
            method: 'post',
            data: formPayload
        }).then((response) => {
            if(response && response.status === 200) {
                const { data } = response;
                const alteredData = data['items'].map((item) => {
                    item['execution'] = 'Validate'
                    return item;
                });
                dispatch({type: SET_UPLOAD_TOPOLOGY_FILE_SUCCESS, 'items': alteredData, 'pages': data['pages'], 'page': data['page']})
            } else {
                dispatch({type: SET_UPLOAD_TOPOLOGY_FILE_ERROR, payload: 'Error occurred while fetching this request!'})
            }
        }).catch((error) => {
            console.error(error);
            dispatch({type: SET_UPLOAD_TOPOLOGY_FILE_ERROR, payload: error.response.data.message});
        });
    } catch(error) {
        console.error(error);
        dispatch({type: SET_UPLOAD_TOPOLOGY_FILE_ERROR, payload: error.message});
    }
}

export const deleteTopologyData = (formPayload) => (dispatch) => {
    try {
        dispatch({type: SET_DELETE_TOPOLOGY_DATA_REQUEST});
        console.log(formPayload)
        axios.post(`/close_loop/topology/handler/delete-topology-data?cad_topology_job_uuid=${formPayload['topologyId']}`).then((response) => {
            if(response && response.status === 200) {
                const { data } = response;
                const alteredData = data['items'].map((item) => {
                    item['execution'] = 'Validate'
                    return item;
                });
                dispatch({type: SET_DELETE_TOPOLOGY_DATA_SUCCESS, 'items': alteredData, 'pages': data['pages'], 'page': data['page']})
            } else {
                dispatch({type: SET_DELETE_TOPOLOGY_DATA_ERROR, payload: 'Error occurred while fetching this request!'})
            }
        }).catch((error) => {
            console.error(error);
            dispatch({type: SET_DELETE_TOPOLOGY_DATA_ERROR, payload: error.response.data.message});
        });
    } catch(error) {
        console.error(error);
        dispatch({type: SET_DELETE_TOPOLOGY_DATA_ERROR, payload: error.message});
    }
}

export const fetchResourceToBeCreated = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_RESOURCES_TO_BE_CREATED_REQUEST});
        axios({
            url: `/close_loop/resources/tobe/created-by?topology_id=${payload['topologyId']}`,
            method: 'get'
        }).then((response) => {
            if(response && response.status === 200) {
                const { data } = response;
                console.log(response);
                dispatch({type: SET_RESOURCES_TO_BE_CREATED_SUCCESS, resources: data['resources']})
            }
        }).catch((error) => {
            console.error(error);
            dispatch({type: SET_RESOURCES_TO_BE_CREATED_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.error(error)
        dispatch({type: SET_RESOURCES_TO_BE_CREATED_ERROR, payload: error.message});
    }
};


export const downloadTopologySchemaFile = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_REQUEST});
        axios({
            url: `/close_loop/download/topology-schema?topology_uuid=${payload['topology_uuid']}`,
            method: 'GET'
        }).then((response) => {
            if(response && response.status === 200) {
                const fileName = response.headers["content-disposition"].split("filename=")[1];
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // IE variant
                    window.navigator.msSaveOrOpenBlob(
                        new Blob([JSON.stringify(response.data, undefined, 2)], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        }),
                        fileName
                    );
                } else {
                    const url = window.URL.createObjectURL(
                        new Blob([JSON.stringify(response.data, undefined, 2)], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        response.headers["content-disposition"].split("filename=")[1]
                    );
                    document.body.appendChild(link);
                    link.click();
                    dispatch({ type: SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_SUCCESS, payload: fileName });
                }
            }
        }).catch((error) => {
            console.error(error)
            dispatch({type: SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.error(error);
        dispatch({type: SET_DOWNLOAD_TOPOLOGY_SCHEMA_FILE_ERROR, payload: error.message});
    }
}